import { differenceInYears, format, startOfMonth } from 'date-fns';
import { BANK_ACCOUNT_KINDS, OPERATION_KINDS } from 'utils/enums';
import { documentAltOnly, numberOnly } from './inputValidation';

const environment = process.env.NODE_ENV;

// export const API_URL =
//   environment === 'production' ? 'https://api.izidolar.com' : 'http://192.168.1.36:1337';

export const API_URL = 'https://api.cambiob2b.com'; //'http://206.189.223.234:1337';//'http://localhost:1337';
export const APP_NAME = process.env.REACT_APP_LOGO === 'exchange' ? 'Exchange' : 'Cambiob2b';
export const APP_NAME_BRAND = process.env.REACT_APP_LOGO === 'exchange' ? 'EXchange' : 'Cambiob2b';

export const ERROR_MESSAGES = {
  REQUIRED: 'Este campo es obligatorio',
  REQUIRED_PLURAL: 'Este campo es obligatorio',
  WRONG_EMAIL: 'Ingrese un correo válido',
  DIGITS_ONLY: 'Ingrese solo números',
  LENGTH: (length: number) => `Ingrese ${length} caracteres`,
  MIN_LENGTH: (minLength: number) => `Ingrese como mínimo ${minLength} caracteres`,
  MAX_LENGTH: (maxLength: number) => `Ingrese como máximo ${maxLength} caracteres`,
};

export const REQUIRED_RULE = {
  required: 'Este campo es obligatorio',
};

export const DOCUMENT_DETAIL = {
  0: 'Boleta',
  1: 'Factura',
  2: 'Ticket de Venta',
  3: 'Nota de Crédito',
  4: 'Nota de Débito',
};

export const OPERATIONS_AUX = {
  C: OPERATION_KINDS.BUY,
  V: OPERATION_KINDS.SELL,
};

export const OPERATIONS = {
  buy: 'Compra de dólares',
  sell: 'Venta de dólares',
};

export const ADMIN_OPERATIONS = {
  buy: 'Cliente Compra',
  sell: 'Cliente Vende',
};

export const OPERATION_STATUS = {
  '0': 'Creado',
  '1': 'Confirmado',
  '2': 'Rechazado',
  '3': 'Pagado',
  '4': 'Firmado',
  '5': 'Emitido',
};

export const BANK_ACCOUNTS = {
  [BANK_ACCOUNT_KINDS.A]: 'Ahorros',
  [BANK_ACCOUNT_KINDS.C]: 'Corriente',
};

export const CUSTOMER_LEVELS = {
  '30': 'Persona Natural',
  '31': 'Persona Jurídica',
  '32': 'Persona Natural',
};

export const USER_LEVELS = {
  '10': 'Administrador',
  '11': 'SEO',
  '20': 'Front Office',
  '21': 'Back Office',
  '22': 'Contador',
};

export const TO_ACCOUNTS = {
  P: 'Propio',
  T: 'Tercero',
};

export const PAY_MODES = {
  RC: 'Transferencia',
  PC: 'Tarjeta de crédito',
};

export const CARDS = {
  DC: "Diner's Club",
  MC: 'MasterCard',
  V: 'Visa',
  AE: 'American Express',
};

export const PROOF_KINDS = {
  mail: 'Correo',
  file: 'Archivo',
};

export const DOC_TYPES = {
  B: 'Boleta',
  F: 'Factura',
  T: 'Ticket',
  C: 'Nota de Crédito',
  D: 'Nota de débito',
};

export const VOUCHER_STATUS_TEXT = {
  0: 'Emitido',
  1: 'Anulado',
  2: 'Pendiente',
  3: 'Error',
  4: 'Reintentar',
};

export const RANGE_KINDS = {
  person: 'Persona Natural',
  company: 'Empresa',
  error: 'Error',
};

export const DOC_VALIDATION = {
  RUC: {
    length: 11,
    validate: (value: string, setValue: any, fieldName: string) =>
      setValue(fieldName, numberOnly(value)),
  },
  DNI: {
    length: 8,
    validate: (value: string, setValue: any, fieldName: string) =>
      setValue(fieldName, numberOnly(value)),
  },
  CE: {
    length: 12,
    validate: (value: string, setValue: any, fieldName: string) =>
      setValue(fieldName, documentAltOnly(value)),
  },
  PSP: {
    length: 12,
    validate: (value: string, setValue: any, fieldName: string) =>
      setValue(fieldName, documentAltOnly(value)),
  },
  DM: {
    length: 9,
    validate: (value: string, setValue: any, fieldName: string) =>
      setValue(fieldName, documentAltOnly(value)),
  },
};

export const YEAR_OPTIONS = Array.from(
  { length: differenceInYears(new Date(), new Date().setFullYear(2021)) + 1 },
  (_, i) => i
).map((i) => ({
  value: (2021 + i).toString(),
  name: (2021 + i).toString(),
}));

export const MONTH_OPTIONS = [
  { value: '0', name: 'Enero' },
  { value: '01', name: 'Febrero' },
  { value: '02', name: 'Marzo' },
  { value: '03', name: 'Abril' },
  { value: '04', name: 'Mayo' },
  { value: '05', name: 'Junio' },
  { value: '06', name: 'Julio' },
  { value: '07', name: 'Agosto' },
  { value: '08', name: 'Septiembre' },
  { value: '09', name: 'Octubre' },
  { value: '10', name: 'Noviembre' },
  { value: '11', name: 'Diciembre' },
  { value: '12', name: 'Enero' },
];

export const DEFAULT_FILTERS: any = {
  text: '',
  number: {
    from: undefined,
    to: undefined,
  },
  date: {
    from: '',
    to: '',
  },
  report_date: {
    from: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
    to: format(new Date(), 'yyyy-MM-dd'),
  },
  select: [],
  all: { value: 'all', name: 'Todos' },
  year: {
    value: new Date().getFullYear().toString(),
    name: new Date().getFullYear().toString(),
  },
  month: {
    value: MONTH_OPTIONS[new Date().getMonth()].value,
    name: MONTH_OPTIONS[new Date().getMonth()].name,
  },
  date_kind: { value: 'year_month', name: 'Mes y año' },
  report_type: { value: 'general', name: 'GRÁFICOS GENERALES' },
};
